import { render, staticRenderFns } from "./EventPricing.vue?vue&type=template&id=9ecf5408"
import script from "./EventPricing.vue?vue&type=script&lang=js"
export * from "./EventPricing.vue?vue&type=script&lang=js"
import style0 from "./EventPricing.vue?vue&type=style&index=0&id=9ecf5408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports